export const api_key = "X36zFNAMmYu2fuR8E4JQS0EJzEMh2dSh";
export const api_url = "https://cyberistanbul.com:5013";
//https://cyberistanbul.com:5013
//http://localhost:5013
export const base_url = "https://market.cyberistanbul.com/";
//https://market.cyberistanbul.com/
//http://localhost:3000
//Website (CyberIstanbul)
export const website_url = "https://cyberistanbul.com/";
